<div class="bot-bg pt-3">

    <div class="role-main-tabs d-flex">
        <div *ngIf="bot" class="role-tab disabled">{{ bot.name }}</div>
        <div class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}" (click)="notifyTabChange('general')">
            {{ 'roles.generalTab' | translate }}
        </div>

        <div *ngIf="bot && bot.botType !== 'document' && bot.botType !== 'message'"
             class="role-tab {{activeTab === 'bot-service' ? 'active-tab': ''}}"
             (click)="notifyTabChange('bot-service')">
            {{ 'roles.botservice' | translate }}
        </div>
    </div>

    <div class="role-main-tabs-content">
        <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
            <div class="role-tab-inner">
                <role-bot-manage [serviceId]="serviceId" [bot]="bot" (modalAddedEvent)="added()"></role-bot-manage>
            </div>
        </div>
        <div *ngIf="bot && bot.botType !== 'document' && bot.botType !== 'message'" class="role-tab-content mb-3 tab-bot-service {{activeTab === 'bot-service' ? 'active-tab': ''}}">
            <service-role [bot]="bot" [serviceId]="serviceId" (saveData)="saveBotSilently()" (mappingReady)="onMappingReady($event)"></service-role>
        </div>
    </div>

</div>